module.exports = __webpack_public_path__ + "static/config-link-below-header-c28b86bb539a9c869bb1bedb7927297b.png";